export default {"src":"/_next/static/media/shopping_bag_blue.61c1ad75.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};